import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Hire ReactJS App Developers for <span> Full-Stack Services</span>
            </h2>
            <p>
              Applications developed using the ReactJS platform can scale
              depending on your business needs while delivering high
              performance. We can guarantee that your applications are powerful,
              smooth, and optimized by using the most up-to-date ReactJS
              technologies available.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Augment Top Reactjs Developers
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>From Zero Starting ReactJS Development</h4>
                  <p>
                    We focus on creating robust web applications from the ground
                    up and from scratch. Developers at our company employ the
                    use of ReactJS to foster scalability, maintainability, and
                    high performance in applications. This way, we guarantee
                    that your project will be based on the most recent
                    technologies and industry standards to produce a tailored
                    solution for your needs.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Application Migration to ReactJS</h4>
                  <p>
                    Upgrade your traditional applications to the new age
                    technologies with our integration solutions using ReactJS.
                    Our team will minimize disruption while also improving the
                    effectiveness, efficiency, and user-friendliness of your
                    application. We take full responsibility for managing the
                    migration process and keeping your application consistent
                    with advancements in ReactJS.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>ReactJS Solution & Systems Architecture</h4>
                  <p>
                    Our professionals implement high-quality solutions and
                    systems architectures in ReactJS within your company's
                    requirements. It is geared toward designing clean,
                    effective, and sustainable architectures that can integrate
                    your application. This way, when it comes to JS and its
                    ecosystem, we make certain that your solution is
                    conceptually ground up.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>ReactJS Native Core Development</h4>
                  <p>
                    Increase your sales with the help of our native application
                    development in ReactJS. We work with React Native to design,
                    develop, and launch blazing-fast, multi-functional,
                    cross-platform, and fully native for iOS and Android
                    applications. Thus, our developers harness the possibilities
                    of ReactJS to create smooth and exciting mobile experiences.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>React UI/UX Design </h4>
                  <p>
                    Improve the design and functionality of your application by
                    hiring our proficient React UI/UX developers. We provide
                    user-friendly, effective, and aesthetically pleasing
                    interfaces that make the user interact with the application.
                    App designers and developers share the same space to
                    guarantee your application will not only have a good design
                    but also be highly intuitive.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>React Maintenance & Support </h4>
                  <p>
                    Scale your ReactJS Applications with our end-to-end
                    maintenance and Support solutions. To make your application
                    stable and up-to-date, we have daily updates, performance
                    boosting, and instant problem-solving capabilities. However,
                    our support team is always on hand to help you with any of
                    these issues that you might face.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
